/*
  innvolo-producto.js
  Cotizador embebido en la ficha. Diseño aprobado el 2026-07-27:
  panel «aire claro» + selector de técnica desplegable.

  DE DÓNDE SALEN LOS NÚMEROS
  Ninguno está escrito aquí. Todos llegan en el JSON que imprime
  sections/innvolo-producto.liquid, leyendo del admin:

    · metaobject innvolo_parametros_precio  → cantidad base y los 6 descuentos
    · metaobject tecnica_marcacion          → nombre, costo y descripción
    · product.price                         → precio de la prenda a la cantidad base
    · innvolo.moq                           → mínimo de ese producto

  Lo único que vive aquí es la ARITMÉTICA de D-016, idéntica a la de
  innvolo-cotizador.js:

    producto  = precio_base × (1 − desc_producto(cantidad))
    marcación = costo_tecnica × (1 − desc_marcacion(cantidad))
    unitario  = producto + marcación

  NO depende del número de colores del logo ni de las posiciones de marcación
  (D-030, confirmado por el usuario). Si alguna vez reaparece esa fórmula:
  está descartada dos veces.

  EL DESGLOSE SUMA
  Las dos primeras líneas van SIN descuento y los escalones se restan debajo.
  Si se pintara el precio ya descontado y además la resta, la columna no
  cuadraría con el total — que es lo que pasaba en la primera versión.
*/

(function () {
  'use strict';

  var raiz = document.querySelector('[data-innvolo-fp]');
  if (!raiz) return;

  var fuente = raiz.querySelector('[data-innvolo-fp-datos]');
  if (!fuente) return;

  var D;
  try {
    D = JSON.parse(fuente.textContent);
  } catch (e) {
    return;
  }

  var P = D.producto || {};
  var TEC = D.tecnicas || [];
  var TOPES = D.topes || [20, 50, 100, 500];
  var DESC = D.descuentos || { producto: {}, marcacion: {} };

  /* Traducción del nombre de la opción de variante a un color de pantalla.
     Es presentación, no dato de negocio — la misma tabla que innvolo-cotizador.js. */
  var COLORES = {
    Negro: '#151a20',
    Blanco: '#fafafa',
    Azul: '#1b3e86',
    Gris: '#98a2ae',
    Rojo: '#b0302f',
    Verde: '#1f6b44',
    Amarillo: '#d8b520',
    Morado: '#5b2e8c',
    Beige: '#d9cdb8',
    'Café': '#6b4630',
    Plateado: '#c9ccd1',
    Transparente: '#dce6ee'
  };
  var ARCOIRIS = 'linear-gradient(135deg,#1b3e86,#b0302f,#d8b520)';

  var fmt = new Intl.NumberFormat('es-CO', { maximumFractionDigits: 0 });
  function cop(n) {
    return '$' + fmt.format(Math.round(n));
  }
  function $(sel) {
    return raiz.querySelector(sel);
  }
  function todos(sel) {
    return Array.prototype.slice.call(raiz.querySelectorAll(sel));
  }

  /* --- D-016: dos curvas independientes, ambas sobre el precio de la base --- */
  function escalonDe(tabla, q) {
    var d = 0;
    for (var i = 0; i < TOPES.length; i++) {
      if (q >= TOPES[i] && tabla[TOPES[i]] != null) d = tabla[TOPES[i]];
    }
    return d;
  }
  function tramoDe(q) {
    var t = TOPES[0];
    for (var i = 0; i < TOPES.length; i++) {
      if (q >= TOPES[i]) t = TOPES[i];
    }
    return t;
  }
  function calcula(q, tec) {
    var dp = escalonDe(DESC.producto, q);
    var dm = escalonDe(DESC.marcacion, q);
    var prenda = P.p * (1 - dp);
    var marca = tec ? tec.c * (1 - dm) : 0;
    return {
      dp: dp,
      dm: dm,
      prenda: prenda,
      marca: marca,
      unit: prenda + marca,
      brutoPrenda: P.p * q,
      brutoMarca: tec ? tec.c * q : 0,
      ahorroPrenda: (P.p - prenda) * q,
      ahorroMarca: tec ? (tec.c - marca) * q : 0,
      total: (prenda + marca) * q
    };
  }

  function porClave(k) {
    for (var i = 0; i < TEC.length; i++) {
      if (TEC[i].k === k) return TEC[i];
    }
    return null;
  }

  var estado = {
    q: P.inicial || P.moq || TOPES[0],
    k: TEC.length ? TEC[0].k : null,
    color: null
  };

  /* ------------------------------------------------------------------ */
  /* colores: solo presentación, no tocan el precio (D-030)              */

  todos('[data-innvolo-fp-color]').forEach(function (b) {
    var nombre = b.dataset.innvoloFpColor;
    if (COLORES[nombre]) b.style.background = COLORES[nombre];
    else b.style.backgroundImage = ARCOIRIS;
    b.addEventListener('click', function () {
      estado.color = nombre;
      todos('[data-innvolo-fp-color]').forEach(function (o) {
        o.setAttribute('aria-pressed', String(o === b));
      });
      var txt = $('[data-innvolo-fp-color-txt]');
      if (txt) txt.textContent = nombre;
    });
  });

  /* galería */
  todos('[data-innvolo-fp-tira]').forEach(function (b) {
    b.addEventListener('click', function () {
      var img = $('.innvolo-fp__img');
      if (!img) return;
      img.removeAttribute('srcset');
      img.src = b.dataset.innvoloFpTira;
      todos('[data-innvolo-fp-tira]').forEach(function (o) {
        if (o === b) o.setAttribute('aria-current', 'true');
        else o.removeAttribute('aria-current');
      });
    });
  });

  /* ------------------------------------------------------------------ */
  /* técnica: el `details` abre y cierra solo; aquí solo se elige         */

  var desp = $('[data-innvolo-fp-desp]');

  todos('[data-innvolo-fp-tec]').forEach(function (b) {
    b.addEventListener('click', function () {
      estado.k = b.dataset.innvoloFpTec;
      todos('[data-innvolo-fp-tec]').forEach(function (o) {
        o.setAttribute('aria-pressed', String(o === b));
      });
      if (desp) desp.open = false;
      pinta();
    });
  });

  /* ------------------------------------------------------------------ */
  /* cantidad                                                            */

  var campo = $('[data-innvolo-fp-cant]');

  todos('[data-innvolo-fp-paso]').forEach(function (b) {
    b.addEventListener('click', function () {
      var paso = parseInt(b.dataset.innvoloFpPaso, 10) || 0;
      estado.q = Math.max(0, estado.q + paso);
      if (campo) campo.value = estado.q;
      pinta();
    });
  });

  if (campo) {
    campo.addEventListener('input', function () {
      var v = parseInt(campo.value, 10);
      estado.q = isNaN(v) || v < 0 ? 0 : v;
      pinta();
    });
  }

  /* ------------------------------------------------------------------ */

  function pintaEscalera(tec) {
    var caja = $('[data-innvolo-fp-escalera]');
    if (!caja) return;
    var activo = tramoDe(estado.q);
    /* Esto se lleva por delante el esqueleto que venía de Liquid. */
    caja.textContent = '';
    caja.removeAttribute('aria-busy');
    TOPES.forEach(function (q) {
      var r = calcula(q, tec);
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-pressed', String(q === activo));
      b.dataset.innvoloFpEsc = q;
      var d = escalonDe(DESC.producto, q);
      b.innerHTML =
        '<span class="u innvolo-cifra">' + fmt.format(q) + ' UDS</span>' +
        '<span class="v innvolo-cifra">' + cop(r.unit) + '</span>' +
        (d > 0
          ? '<span class="d innvolo-cifra">&minus;' + Math.round(d * 100) + '&nbsp;%</span>'
          : '<span class="d">&nbsp;</span>');
      b.addEventListener('click', function () {
        estado.q = q;
        if (campo) campo.value = q;
        pinta();
      });
      caja.appendChild(b);
    });
  }

  function fila(etiqueta, valor, ahorro) {
    return (
      '<div class="innvolo-fp__fila' + (ahorro ? ' innvolo-fp__fila--ahorro' : '') + '">' +
      '<span>' + etiqueta + '</span><span class="innvolo-cifra">' + valor + '</span></div>'
    );
  }

  function pintaCuentas(tec) {
    var caja = $('[data-innvolo-fp-cuentas]');
    if (!caja) return;

    var minimo = P.moq || TOPES[0];
    if (estado.q < minimo) {
      caja.innerHTML =
        '<p class="innvolo-fp__aviso">La marcación arranca en <b>' +
        fmt.format(minimo) +
        ' unidades</b>: por debajo no se amortiza el montaje. Sube la cantidad para ver el precio.</p>';

      /* La barra de celular dice lo mismo que el panel, también cuando no hay
         precio que dar. Si se quedara con el total anterior, mentiría. */
      var totalM = $('[data-innvolo-fp-accion-total]');
      var detalleM = $('[data-innvolo-fp-accion-detalle]');
      if (totalM) totalM.textContent = 'Desde ' + fmt.format(minimo) + ' uds';
      if (detalleM) detalleM.textContent = 'Sube la cantidad para ver el precio';
      return;
    }

    var r = calcula(estado.q, tec);
    var h = '';
    h += fila(
      (P.corto || P.t) + ' × ' + fmt.format(estado.q),
      cop(r.brutoPrenda),
      false
    );
    if (tec) {
      h += fila(tec.n + ' × ' + fmt.format(estado.q), cop(r.brutoMarca), false);
    }
    if (r.dp > 0) {
      h += fila(
        'Escalón ' + fmt.format(tramoDe(estado.q)) + '+ · producto &minus;' + Math.round(r.dp * 100) + '&nbsp;%',
        '&minus; ' + cop(r.ahorroPrenda),
        true
      );
    }
    if (tec && r.dm > 0) {
      h += fila(
        'Escalón ' + fmt.format(tramoDe(estado.q)) + '+ · marcación &minus;' + Math.round(r.dm * 100) + '&nbsp;%',
        '&minus; ' + cop(r.ahorroMarca),
        true
      );
    }
    h +=
      '<div class="innvolo-fp__total"><span class="k"><b>Precio unitario</b>' +
      '<span class="innvolo-cifra">' + cop(r.unit) + ' c/u</span></span>' +
      '<span class="v">' + cop(r.total) + '</span></div>';

    caja.innerHTML = h;
    caja.removeAttribute('aria-busy');

    /* La barra fija de celular repite el total del panel. Se rellena aquí, en
       la misma pasada, para que no puedan decir cosas distintas. */
    pintaAccion(r, tec);
  }

  /* Barra de acción de celular (decisión 1B). Si no existe —escritorio antiguo,
     plantilla sin la barra— esto no hace nada. */
  function pintaAccion(r, tec) {
    var total = $('[data-innvolo-fp-accion-total]');
    var detalle = $('[data-innvolo-fp-accion-detalle]');
    if (!total) return;

    total.textContent = cop(r.total);
    if (detalle) {
      detalle.textContent =
        fmt.format(estado.q) + ' uds · ' + (tec ? tec.n.toLowerCase() : 'sin marcación');
    }
  }

  function pinta() {
    var tec = estado.k ? porClave(estado.k) : null;

    /* resumen del desplegable y costos de cada opción */
    var nombre = $('[data-innvolo-fp-tec-nombre]');
    if (nombre && tec) nombre.textContent = tec.n;

    var costo = $('[data-innvolo-fp-tec-costo]');
    if (costo && tec) costo.textContent = 'desde ' + cop(tec.c * (1 - escalonDe(DESC.marcacion, TOPES[TOPES.length - 1]))) + ' c/u';

    TEC.forEach(function (t) {
      var c = raiz.querySelector('[data-innvolo-fp-opcion-costo="' + t.k + '"]');
      if (c) {
        c.textContent =
          'desde ' + cop(t.c * (1 - escalonDe(DESC.marcacion, TOPES[TOPES.length - 1])));
      }
    });

    var desc = $('[data-innvolo-fp-tec-desc]');
    if (desc) desc.textContent = tec ? tec.d || '' : '';

    pintaEscalera(tec);
    pintaCuentas(tec);

    /* el enlace de cotizar lleva la selección al módulo /cotizar */
    var pedir = $('[data-innvolo-fp-pedir]');
    if (pedir) {
      var base = pedir.getAttribute('href').split('?')[0];
      var q = [];
      q.push('p=' + encodeURIComponent(P.handle || ''));
      q.push('cant=' + estado.q);
      if (estado.k) q.push('tec=' + encodeURIComponent(estado.k));
      if (estado.color) q.push('color=' + encodeURIComponent(estado.color));
      pedir.setAttribute('href', base + '?' + q.join('&'));
    }
  }

  /* ------------------------------------------------------------------
     La foto
     El hueco late hasta que la imagen termina, y entonces entra fundida. Se
     comprueba `complete` porque una foto en caché puede haber cargado antes de
     que este script llegue a correr: sin esa comprobación, el esqueleto se
     quedaría brillando para siempre encima de una imagen ya lista.
     ------------------------------------------------------------------ */
  var caja_foto = $('[data-innvolo-fp-foto]');
  if (caja_foto) {
    var foto = caja_foto.querySelector('img');

    var lista = function () {
      caja_foto.dataset.innvoloCargada = 'si';
    };

    if (!foto || foto.complete) {
      lista();
    } else {
      foto.addEventListener('load', lista);
      /* Si la imagen falla, tampoco se deja el esqueleto latiendo: se apaga y
         se ve el hueco quieto, que al menos no promete nada. */
      foto.addEventListener('error', lista);
    }

    /* Al cambiar de miniatura, el `src` nuevo puede tardar. */
    if (foto) {
      new MutationObserver(function () {
        if (!foto.complete) {
          caja_foto.dataset.innvoloCargada = 'no';
          foto.addEventListener('load', lista, { once: true });
        }
      }).observe(foto, { attributes: true, attributeFilter: ['src'] });
    }
  }

  pinta();
})();
